export default __webpack_public_path__ + "static/media/ai-selection.dc68b163.png";